import { Grid, Button } from "@material-ui/core";
import { useHistory } from "react-router";
import useStyles from "../../../../../styles";

export default function LoginSignUp() {
  const classes = useStyles();
  const history = useHistory();
  return (
    <Grid item className={classes.LoginSignUpContainer}>
      <Button
        variant="text"
        className={`${classes.fontSize12} ${classes.loginButton}`}
        onClick={() => history.push("/")}
      >
        خانه
      </Button>
      <Grid item className={classes.verticalLine} />

      {/* <Button
        variant="text"
        className={`${classes.fontSize12} ${classes.loginButton}`}
        onClick={() => history.push("/enghelab/school")}
      >
        مدرسه انقلاب
      </Button> */}
      {/* <Grid item className={classes.verticalLine} /> */}
      <Button
        variant="text"
        className={`${classes.fontSize12} ${classes.loginButton}`}
        onClick={() => history.push("/login")}
      >
        ورود
      </Button>
      <Grid item className={classes.verticalLine} />
      <Button
        variant="contained"
        className={`${classes.fontSize12} ${classes.signUpButton}`}
        onClick={() => history.push("/signup")}
      >
        ثبت‌نام
      </Button>
    </Grid>
  );
}
